"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importDefault(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.PasswordCreationFieldNames.password]: '',
    token: '',
};
const PasswordCreationForm = ({ location }) => (react_1.default.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.PasswordCreationSchema, onSubmitPayload: ({ password }) => {
        const { token } = carabiners_1.createSearchObject(location.search);
        const payload = {
            password,
            token
        };
        return api_payloads_1.passwordCreationPayload(payload);
    }, formKey: services_1.endpoints.login },
    react_1.default.createElement("div", { className: styles_scss_1.default.passwordCreationInputs },
        react_1.default.createElement("div", { className: styles_scss_1.default.passwordCreationInputRow },
            react_1.default.createElement(fields_1.PasswordInputField, { name: field_names_1.PasswordCreationFieldNames.password, label: constants_1.default.passwordCreation.enterNewPassword, placeholder: constants_1.default.passwordCreation.enterNewPassword }))),
    react_1.default.createElement(form_error_1.default, { formKey: services_1.endpoints.changePassword }),
    react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
        react_1.default.createElement(buttons_1.SubmitButton, { disableOnErrors: true, ariaLabel: constants_1.default.general.next, title: constants_1.default.passwordCreation.saveNewPassword, className: styles_scss_1.default.submitButton }))));
exports.default = react_router_1.withRouter(PasswordCreationForm);
